import { useToast } from '@app/core/notifications';
import { auditMentionsAuditMentionsMatchesCreateManual } from '@mi-front/api-v2';
import { AuditLiveMention } from '@mi-front/core';
import { Modal } from '@mi-front/ui';
import { FormattedMessage, useIntl } from 'react-intl';
import { MatchesAddScreenPropsP } from '../matches-add/screen_p';
import { MentionManualForm } from './MentionManualForm';

type Props = Pick<MatchesAddScreenPropsP, 'station' | 'datetime' | 'show' | 'onHide'> & {
  onSuccess?: (match: AuditLiveMention) => unknown;
};

/**
 * Modal flow to create a manual live mention via api-v2.
 */
export function MentionsAddPage(p: Props) {
  const { station, datetime, show, onHide, onSuccess } = p;
  const { $t } = useIntl();
  const { notifySuccess, notifyError } = useToast();

  return (
    <Modal
      size="md"
      show={show}
      onHide={onHide}
      showCloseButton={false}
      noBody
      title={
        <div style={{ display: 'flex' }}>
          <FormattedMessage
            id="audit.liveMentionsAdd.title"
            defaultMessage="Crear mención manual"
          />
        </div>
      }
    >
      <MentionManualForm
        station={station}
        datetime={datetime}
        submitFn={async (data) => {
          try {
            const match = (await auditMentionsAuditMentionsMatchesCreateManual(
              {
                datetime: data.datetime,
                name: data.name,
                description: data.description,
              },
              { station: station.id },
            )) as unknown as AuditLiveMention;

            notifySuccess(
              $t({
                id: 'audit.liveMentions.created',
                defaultMessage: 'Mención manual creada',
              }),
            );

            onHide();

            onSuccess?.(match);
          } catch (err) {
            notifyError(
              $t({
                id: 'audit.liveMentions.createError',
                defaultMessage: 'Mención no creada, intente de nuevo',
              }),
            );

            throw err;
          }
        }}
        cancel={onHide}
      />
    </Modal>
  );
}
